import './sidebar.scss';
import React from 'react';
import { Link } from 'react-router';

const menuItems = [{
    title: 'Permissions',
    link: '/settings/permissions'
},
{
    title: 'PowerShell',
    link: '/settings/powershell'
},
{
    title: 'About',
    link: '/settings/about'
}];

const SettingSidebarButton = React.createClass({
    render: function() {
        const pathname = this.props.path || '';
        const className = (pathname.match(this.props.link)) ? 'active' : '';
        return <Link to={this.props.link} className={className}>{this.props.title}</Link>;
    }
});

const SettingSidebar = React.createClass({
    render: function() {
        const items = menuItems.map((item, index)=>{
            return <li key={index}><SettingSidebarButton title={item.title} link={item.link} path={this.props.path} /></li>;
        });

        return <div>
            <h1>Settings</h1>
            <ul>
                {items}
            </ul>
        </div>;
    }
});

export default SettingSidebar;



// WEBPACK FOOTER //
// ./src/components/common/PageLayout/Setting/sidebar.jsx